<div class="main-container">
  <!-- text -->
  <p class="contact-us-title">Contact Us</p>
  <div class="divider"></div>
  <div class="contact-us-container">

    <div *ngIf="isBusy" style="display: flex;justify-content: center;">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="contactUs" [innerHTML]="contactUs | safe_html"></div>

  </div>
</div>